<template>
  <div>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="isOpen"
        :show-close="true"
        title="Xoá dữ liệu trùng lặp"
        width="40%"
    >
      <div>
        <el-row type="flex" :gutter="10">
          <el-col :span="12">
            <el-date-picker
                style="width: 90%"
                size="small"
                v-model="dataInput.date"
                type="date"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                placeholder="Chọn ngày"
                :clearable="true"
            ></el-date-picker>
          </el-col>

          <el-col :span="12">
            <el-collapse v-model="activeName" accordion>
              <el-collapse-item title="Điểm danh" name="attendance">
                <div class="container_options">
                  <el-button
                      type="primary"
                      size="small"
                      :loading="isLoading.checkAttendance"
                      @click="checkAttendanceDuplicate()"
                  >
                    KTra điểm danh
                  </el-button>
                  <span class="element_count">KQ: {{ count.attendance }}</span>
                  <el-button
                      type="danger"
                      size="small"
                      :disabled="!count.attendance"
                      :loading="isLoading.deleteAttendance"
                      @click="deleteAttendanceDuplicate()"
                  >
                    Xóa điểm danh
                  </el-button>
                </div>
              </el-collapse-item>
              <el-collapse-item title="Nhận xét" name="evaluate">
                <div class="container_options">
                  <el-button
                      type="primary"
                      size="small"
                      :loading="isLoading.checkEvaluate"
                      @click="checkEvaluateDuplicate()"
                  >KTra nhận xét
                  </el-button
                  >
                  <span class="element_count">KQ: {{ count.evaluate }}</span>
                  <el-button
                      type="danger"
                      size="small"
                      :disabled="!count.evaluate"
                      :loading="isLoading.deleteEvaluate"
                      @click="deleteEvaluateDuplicate()"
                  >Xóa nhận xét
                  </el-button
                  >
                </div>
              </el-collapse-item>
              <el-collapse-item title="Mã QR" name="qr_code">
                <div class="container_options">
                  <el-button
                      type="primary"
                      size="small"
                      :loading="isLoading.checkQrCode"
                      @click="checkQrCodeDuplicate()"
                  >KTra mã QR
                  </el-button
                  >
                  <span class="element_count">KQ: {{ count.qrCode }}</span>
                  <el-button
                      type="danger"
                      size="small"
                      :disabled="!count.qrCode"
                      :loading="isLoading.deleteQrCode"
                      @click="deleteQrCodeDuplicate()"
                  >Xóa mã QR
                  </el-button
                  >
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-col>
        </el-row>
      </div>

      <div slot="footer">
        <div>
          <el-button type="danger" @click="handleClose">
            <i class="el-icon-circle-close"/>
            Đóng
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import OtherService from "@/services/CommonService/OtherService";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      isLoading: {
        checkAttendance: false,
        deleteAttendance: false,
        checkEvaluate: false,
        deleteEvaluate: false,
        checkQrCode: false,
        deleteQrCode: false,
      },

      count: {
        attendance: "",
        evaluate: "",
        qrCode: ""
      },

      dataInput: {
        date: "",
      },

      activeName: "",
    }
  },
  watch: {},
  methods: {
    handleClose() {
      this.$emit("closeDialog", "delete_data_duplicate");
      this.resetData();
    },

    resetData() {
      this.dataInput.date = "";
      this.activeName = "";
    },

    checkDateDuplicate() {
      if (this.dataInput.date === "") {
        this.$message({
          message: "Chọn ngày xóa dữ liệu trùng",
          type: "error",
        });
        throw null;
      }
    },

    checkAttendanceDuplicate() {
      this.checkDateDuplicate();
      this.isLoading.checkAttendance = true;
      OtherService.getAttendanceDuplicateServiceForSupperPlus(this.dataInput.date)
          .then((resp) => {
            this.count.attendance = resp.data.data;
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          })
          .finally(() => {
            this.isLoading.checkAttendance = false;
          });
    },

    deleteAttendanceDuplicate() {
      this.checkDateDuplicate();
      this.$confirm(
          "Bạn có chắc chắn muốn xóa điểm danh trùng không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(() => {
        this.isLoading.deleteAttendance = true;
        OtherService.deleteAttendanceDuplicateServiceForSupperPlus(this.dataInput.date)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
              this.checkAttendanceDuplicate();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              this.isLoading.deleteAttendance = false;
            });
      });
    },

    checkEvaluateDuplicate() {
      this.checkDateDuplicate();
      this.isLoading.checkEvaluate = true;
      OtherService.getEvaluateDuplicateServiceForSupperPlus(this.dataInput.date)
          .then((resp) => {
            this.count.evaluate = resp.data.data;
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          })
          .finally(() => {
            this.isLoading.checkEvaluate = false;
          });
    },

    deleteEvaluateDuplicate() {
      this.checkDateDuplicate();
      this.$confirm(
          "Bạn có chắc chắn muốn xóa nhận xét trùng không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(() => {
        this.isLoading.deleteEvaluate = true;
        OtherService.deleteEvaluateDuplicateServiceForSupperPlus(this.dataInput.date)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
              this.checkEvaluateDuplicate();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              this.isLoading.deleteEvaluate = false;
            });
      });
    },

    checkQrCodeDuplicate() {
      this.checkDateDuplicate();
      this.isLoading.checkQrCode = true;
      OtherService.getQrCodeDuplicateServiceForSupperPlus(this.dataInput.date)
          .then((resp) => {
            this.count.qrCode = resp.data.data;
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          })
          .finally(() => {
            setTimeout(() => {
              this.isLoading.checkQrCode = false;
            }, 500);
          });
    },

    deleteQrCodeDuplicate() {
      this.checkDateDuplicate();
      this.$confirm(
          "Bạn có chắc chắn muốn xóa mã QR trùng không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(() => {
        this.isLoadingdeleteQrCode = true;
        OtherService.deleteQrCodeDuplicateServiceForSupperPlus(this.dataInput.date)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
              this.checkQrCodeDuplicate();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              this.isLoading.deleteQrCode = false;
            });
      });
    },
  }
}
</script>

<style scoped lang="scss">
.container_options {

}

.element_count {
  width: 60px;
  display: inline-block;
  padding: 0 10px;
}
</style>